<template>
  <SmallSquare content="设置关闭后，对应角色扫码无法进入导购活动；若二维码同时配置营销活动和导购活动，关闭角色扫码直接进入扫码营销活动" :padding="true" />
  <a-card :bordered="false">
    <a-form ref='form' :model='ruleForm' :initialValues="search" :onFinish='pageSearchChange' :colon='false' :label-col="{span:3}">
        <a-form-item label="是否开启导购功能" name='' :wrapper-col="{ span: 17,offset:1}" help="(关闭后,导购员扫码进入溯源页或参与扫码营销活动,设置的导购活动不生效)">
        <a-radio-group v-model:value="dataMore.is_enable_guide">
          <a-radio :value="0">不开启</a-radio>
          <a-radio :value="1">开启</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="门店负责人能否参与活动" name='' :wrapper-col="{ span: 17,offset:1}">
        <a-radio-group v-model:value="dataMore.is_guide_store_director">
          <a-radio :value="1">参加</a-radio>
          <a-radio :value="0">不参加</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="门店店长能否参与活动" name='' :wrapper-col="{ span: 17,offset:1}">
        <a-radio-group v-model:value="dataMore.is_guide_store_manager">
          <a-radio :value="1">参加</a-radio>
          <a-radio :value="0">不参加</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="门店店员能否参与活动" name='' :wrapper-col="{ span: 17,offset:1}">
        <a-radio-group v-model:value="dataMore.is_guide_store_clerk">
          <a-radio :value="1">参加</a-radio>
          <a-radio :value="0">不参加</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4,offset:1}" class='m-t-25'>
        <a-button type="primary" v-has:guideSettingsSubmit="onSubmit">
          保存设置
        </a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { onMounted, reactive, toRefs } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import { isArray } from "lodash";
import {get_guide_scan_config,update_guide_scan_config} from '@/api/guide'
export default {
  name: "integralSet",
  setup() {
    const state = reactive({
      dataMore: {
        is_enable_guide:0,
        is_guide_store_director:0,
        is_guide_store_manager:0,
        is_guide_store_clerk: 0,
      },
    });
    const onSubmit = async () => {
      let res = await update_guide_scan_config(state.dataMore).then((res) => res.data);
     iscode(res,true)
    };
    const initData = async () => {
      let res = await get_guide_scan_config().then((res) => res.data);
      if (iscode(res)) {
        if (!isArray(res.data)) {
          state.dataMore = res.data;
        }
      } else {
        message.error(res.msg);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      onSubmit,
    };
  },
};
</script>